document.addEventListener('alpine:init', () => {
  const row_item = {
    search_q: '',
    variant: null,
    flags: {
      search_performed: false
    }
  }

  Alpine.data('BulkOrderForm', () => ({
    search_q: '',
    rows: 5,
    search_results: [],
    row_items: [],
    selected_variants: [],
    init() {
      this.InitSelf();
      this.InitWatchers();
    },
    InitSelf() {
      this.rows = parseInt(this.$el.dataset.rows) || 5;
      this.row_items = new Array(this.rows).fill().map(() => ({ ...row_item }));
    },
    InitWatchers() {
      this.$watch('row_items', () => {
        this.selected_variants = this.row_items
          .filter(item => item.variant !== null)
          .map(item => item.variant);
      });
    },
    e_AddRow() {
      this.row_items.push({ ...row_item });
    },
    async e_SearchProduct(index, item) {
      // console.log('Predictive Search triggered for row index:', index);
      let url_decoded = `${window.Shopify.routes.root}search/suggest?q=${item.search_q}&resources[limit]=10&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku,tag&resources[options][unavailable_products]=last&section_id=predictive-search-sku`
      let url = encodeURI(url_decoded);

      let res = await fetch(url).then(response => response.text());
      // console.log(`Predictive Search response for ${item.search_q}:`, res);
      let $res = new DOMParser().parseFromString(res, "text/html");
      let $list = $res.querySelectorAll('.predictive-search__item');
      this.search_results = Array.from($list).map(item => item.outerHTML);
      item.flags.search_performed = true;
    },
    e_SelectItem(e) {
      let item = this.row_items.find(i => i.flags.search_performed && i.search_q.length > 0);
      let product = JSON.parse(e.currentTarget.dataset.product);
      let options_with_values = JSON.parse(e.currentTarget.dataset.options_with_values);
      product.options_with_values = options_with_values;
      product.has_only_default_variant = JSON.parse(e.currentTarget.dataset.product_has_only_default_variant);
      item.product = product;
      if (item) {
        let variants = product.variants;
        // only include available variants
        variants = variants.filter(v => v.available); 
        variants.forEach((variant, idx) => {
          // augment variant data, if not present, use default product image
          variant.featured_image_src = variant.featured_image ? variant.featured_image.src : e.currentTarget.dataset.product_image;
          variant.quantity = 1;
          variant.inventory_quantity = parseInt(JSON.parse(e.currentTarget.dataset.variants_inventory)[idx]);
          variant.url = e.currentTarget.dataset.product_url + `?variant=${variant.id}`;
        });
        // console.log('Parsed variants:', variants);

        // find specific variant if matched
        let specific_variant = variants.find(v => v.title == this.item.search_q || v.sku == item.search_q);
        // console.log('Selected variant:', specific_variant);
        if (specific_variant) { 
          item.variant = specific_variant;
        }
        else {
          // Take first available variant
          item.variant = variants.find(v => v.available) || variants[0];
        }
        item.all_variants = variants;

        // Reset search state
        this.e_CloseSearch();
      }
      // console.log(e, e.currentTarget, e.target);
    },
    e_onVariantChange(e, item) {
      let $variant_options = e.currentTarget.closest('.variant-options');
      let values = Array.from($variant_options.querySelectorAll('select')).map(select => select.value);
      let variant = item.all_variants.find(v => {
        return v.options.every((opt, idx) => opt === values[idx]);
      });
      if (variant) {
        item.variant = variant;
      }
    },
    e_CloseSearch() {
      let item = this.row_items.find(i => i.flags.search_performed && i.search_q.length > 0);
      if (item) {
        // Reset search state
        item.search_q = '';
        item.flags.search_performed = false;
        this.search_results = [];
      }
    },
    async e_AddItemstoCart() {
      if (this.selected_variants.length === 0) return;
      
      let items = this.selected_variants.map(variant => ({
        id: variant.id,
        quantity: variant.quantity || 1
      }));
      try {
        let res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });
        if (res.ok) {
          // Successfully added to cart, refresh cart drawer
          this.u_RefreshCart();

          // Reset the form
          this.InitSelf();
        } 
        else {
          let errorData = await res.json();
          console.error('Error adding items to cart:', errorData);
        }
      } 
      catch (error) {
        console.error('Network error adding items to cart:', error);
      }
    },
    e_RemoveRow(index) {
      this.row_items.splice(index, 1); // Remove the row at the specified index
      this.row_items.push({ ...row_item }); // Add a new empty row to maintain the total number of rows
    },
    get TotalAmount() {
      return this.selected_variants.reduce((total, variant) => {
        return total + (variant.price * (variant.quantity || 1));
      }, 0);
    },
    u_RefreshCart() {
      // Dispatch a custom event to notify other components to refresh the cart
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      }, 300);
    },
    u_FormatMoney(cents) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(cents / 100);
    },
  }));
});